__turbopack_context__.v({
  "avatar": "styles-module__RaGe_G__avatar",
  "avatarWrapper": "styles-module__RaGe_G__avatarWrapper",
  "listItem": "styles-module__RaGe_G__listItem",
  "shopText": "styles-module__RaGe_G__shopText",
  "textContainer": "styles-module__RaGe_G__textContainer",
  "userItem": "styles-module__RaGe_G__userItem",
  "username": "styles-module__RaGe_G__username",
});
